<div class="border-solid -border-2 rounded-md p-2 border-gray-200 -bg-gray-100 drop-shadow-sm">
  <a routerLink="/tea-item/{{ teaItem.slug }}">
    <h2 class="text-xl font-bold text-green-900 text-center pb-2">{{ teaItem.name }} </h2>
  </a>
  <a routerLink="/tea-item/{{ teaItem.slug }}" class="image-container block">
    <!-- Loading placeholder -->
    @if (imageLoading) {
      <div class="image-loading-placeholder flex items-center justify-center">
        <span class="text-gray-500 text-sm">Loading image...</span>
      </div>
    }

    <!-- Optimized image -->
    @if (!imageLoading && optimizedImageUrl) {
      <img
        [ngSrc]="optimizedImageUrl"
        [alt]="teaItem.name + ' tea image'"
        width="800"
        height="800"
        class="rounded-md dropshadow w-full"
        priority="false"
        loading="lazy"
        placeholder
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw">
    }

    <!-- Fallback for no image -->
    @if (!imageLoading && !optimizedImageUrl) {
      <div class="w-full bg-gray-300 rounded-md flex items-center justify-center" style="aspect-ratio: 1/1;">
        <span class="text-gray-600">No image available</span>
      </div>
    }
  </a>

  <!-- Debug info (temporary) -->
  <!-- <div class="text-xs text-gray-400 mt-2">
  <p>Image Loading: {{ imageLoading }}</p>
  <p>Optimized URL: {{ optimizedImageUrl ? 'Available' : 'None' }}</p>
  <p>Tea Item Slug: {{ teaItem?.slug || 'No slug' }}</p>
</div> -->

<!-- <p>
{{ teaItem.description | slice:0:100 }}...
</p> -->
<!-- <p class="text-center">
<span class="font-semibold text-green-700"><a routerLink="/tea-item/{{ teaItem.slug }}">Learn More...</a></span>
</p> -->
<!-- {{teaItem.imageURL|json}} -->
</div>
